@if (dataLoaded()) {
  <div class="stu-work-detail-issue">
    <div class="pre-page spen-mod-heading lv-1">
      <h1 class="heading-text">
        <a (click)="onBack()"><i class="fa fa-chevron-left"></i></a>アンケート回答編集
      </h1>
    </div>
    <div class="template">
      <div class="descr-heading">アンケートの回答内容はアンケート機能から変更してください。</div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group albums">
          <div class="row">
            <div class="col-md-3 col-xs-12">
              <p class="label-input">アルバム</p>
            </div>
            <div class="col-md-9 col-xs-12">
              @if (activityRecord.albums_activity_records?.length > 0) {
                @for (albums_activity_record of activityRecord.albums_activity_records; track albums_activity_record) {
                  <p class="album">
                    ・ <span class="album-name">{{ albums_activity_record.album_name }}</span>
                    @if (albums_activity_record.can_delete) {
                      <a (click)="deleteActivityRecordFromAlbum(albums_activity_record)">取り出す</a>
                    }
                  </p>
                }
              } @else {
                未登録
              }
            </div>
          </div>
        </div>
        @if (activityRecord.space_name) {
          <p class="classname">※{{ activityRecord.space_name }}に保存されます</p>
        }
        <div class="block-last">
          <button type="submit" class="spen-mod-btn is-primary" [disabled]="isSubmitting">編集を完了する</button>
          <button type="button" class="spen-mod-btn" (click)="onBack()">戻る</button>
        </div>
      </form>
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
